var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-editor"}},[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.element)?_c(_vm.element,{tag:"component",attrs:{"editor":_vm.$options.editor,"opts":_vm.$options.opts,"payload":_vm.$options.payload}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }